module.exports = __webpack_public_path__ + "static/media/MeriBai.a5f78cf7.mp4";